/**
 * Image montrée par le MJ (même nœud Realtime DB qu'Aria : imagePanel/{campagne}).
 * Format : {url, memberAvailable: [uid de personnage], immersive: Boolean, caption, shownAt}.
 * `caption` et `shownAt` sont propres à VtM (Aria les ignore).
 */

/** L'image est-elle affichée sur la fiche de ce personnage ? */
export const isSceneShownTo = (scene, characterUid) => Boolean(
  scene && scene.immersive && scene.url && (scene.memberAvailable || []).includes(characterUid),
);

/** L'image est-elle affichée en ce moment (vue du MJ) ? */
export const isSceneLive = (scene) => Boolean(scene && scene.immersive && scene.url);

/** Dimensions réduites pour que le plus grand côté ne dépasse pas maxSide. */
export const fitWithin = (width, height, maxSide) => {
  const scale = Math.min(1, maxSide / Math.max(width, height));
  return {width: Math.round(width * scale), height: Math.round(height * scale)};
};

/**
 * Clé de l'image telle que ce personnage la voit : change à chaque fois que le MJ la montre,
 * même s'il remontre la même image. Null si elle n'est pas montrée à ce personnage.
 */
export const sceneShowKey = (scene, characterUid) => (isSceneShownTo(scene, characterUid) ? String(scene.shownAt || scene.url) : null);

/**
 * Faut-il jouer l'entrée de scène ? Oui quand l'image vient d'être montrée,
 * pas au chargement de la page (`previousKey` undefined : premier état reçu).
 */
export const shouldPlaySceneIntro = (previousKey, nextKey) => previousKey !== undefined && nextKey !== null && nextKey !== previousKey;
